import { debounce } from './modules/utilities';

// Alpine.js
import Alpine from 'alpinejs';
global.Alpine = Alpine;

// Import or define any Alpine components here
import './alpine-components/siteNav';
Alpine.start();

// Lazy load images
import Lazyload from 'vanilla-lazyload';

// Create Lazy load instance
// eslint-disable-next-line
var lazyLoadInstance = new Lazyload({
    elements_selector: '.lazy'
    // ... more custom settings?
});

let scrollDirection;
let isScrolling;
let scrollY = window.scrollY;
const main_nav_container = document.getElementById('main-navigation__container');
const site_wide_notification = document.getElementById('site-wide-notification-bar');
const site_wide_notification_height = site_wide_notification ? site_wide_notification.getBoundingClientRect().height : 0;
const original_main_nav_height = main_nav_container.getBoundingClientRect().height;

function updateStickyNav() {
    if (window.innerWidth < 1025) {
        return;
    }

    if (window.scrollY < scrollY) {
        scrollDirection = 'up';
    } else if (window.scrollY > scrollY) {
        scrollDirection = 'down';
    } else {
        scrollDirection = 'same';
    }

    window.clearTimeout(isScrolling);

    if(window.scrollY > 0 && !main_nav_container.classList.contains('is-sticky') ) {

        main_nav_container.parentNode.style.paddingTop = `${main_nav_container.getBoundingClientRect().height}px`;

        main_nav_container.classList.add('is-sticky');

    }

    if(window.scrollY === 0 && main_nav_container.classList.contains('is-sticky')) {

        main_nav_container.parentNode.style.paddingTop = '';

        main_nav_container.classList.remove('is-sticky');

    }

    if(window.scrollY <= (original_main_nav_height + site_wide_notification_height)) {

        isScrolling = setTimeout( () => {
            console.log('Scrolling stopped');
            if(window.scrollY <= (original_main_nav_height + site_wide_notification_height) && scrollDirection === 'up') {
                window.scrollTo({ top: 0, behavior: 'smooth'});
            }
        }, 1500);

    }
}

updateStickyNav();

window.addEventListener('scroll', function() {

    updateStickyNav();

    scrollY = window.scrollY;

}, { passive: true });

window.addEventListener('resize', debounce(() => {
    if (window.innerWidth < 1025 && main_nav_container.classList.contains('is-sticky')) {
        main_nav_container.parentNode.style.paddingTop = '';
        main_nav_container.classList.remove('is-sticky');
    }
}));

// ===================================================
// Set nav-header-height css variable
// ===================================================
const nav_header_css_var = '--nav-header-height';
const nav_header = document.querySelector('#main-navigation__container');

document.documentElement.style.setProperty(nav_header_css_var, `${parseFloat(nav_header.getBoundingClientRect().height.toFixed(4))}px`);

window.addEventListener('resize', debounce(() => {

    if (document.body.classList.contains('mobile-nav-is-open')) {
        return;
    }

    document.documentElement.style.setProperty(nav_header_css_var, `${parseFloat(nav_header.getBoundingClientRect().height.toFixed(4))}px`);

}));